import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getMessaging, isSupported } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: "AIzaSyASuGctsddm00eCl-ihlWLZgzRtuFAbr5w",
  authDomain: "amatyaa-d7d4c.firebaseapp.com",
  projectId: "amatyaa-d7d4c",
  storageBucket: "amatyaa-d7d4c.firebasestorage.app",
  messagingSenderId: "275683530698",
  appId: "1:275683530698:web:723d9965ef012a1182e133",
  measurementId: "G-XLESYF91YJ"
};

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

// messaging is only supported in browsers that support service workers + Push API
export const messaging = isSupported().then(yes => yes ? getMessaging(app) : null)

export default app

